import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { DatepickerCalendarLocaleType, DatepickerSelectedDateType, DatepickerShowDateType } from "@website/ui/datepicker/datepicker.types";
import { addMonth, createShowDatesArray, getShowDatesInitial, getToday, subtractMonth } from "@website/ui/datepicker/datepicker.utils";
import { useEffectJustChanges } from "@website/utils/use-effect-just-changes/useEffectJustChanges";
import { useState } from "react";
export const INITIAL_SHOW_DATES_NUMBER = 2;
export const useShowDate = (calendarLocale, scrollToTop, value, view) => {
  const $ = _c(42);
  const {
    isDesktop
  } = useViewPort();
  let t0;
  if ($[0] !== calendarLocale || $[1] !== value[0]?.dateTime) {
    t0 = () => getShowDatesInitial(value[0]?.dateTime, INITIAL_SHOW_DATES_NUMBER, calendarLocale);
    $[0] = calendarLocale;
    $[1] = value[0]?.dateTime;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [showDates, setShowDates] = useState(t0);
  let t1;
  if ($[3] !== calendarLocale || $[4] !== showDates || $[5] !== value || $[6] !== view) {
    t1 = () => {
      const slicedShowDates = view === "mobile" ? showDates.slice(0, 1) : showDates;
      if (value?.some(index => !slicedShowDates.some(index_ => index_.year === index.year && index_.month === index.month))) {
        setShowDates(getShowDatesInitial(value[0].dateTime, INITIAL_SHOW_DATES_NUMBER, calendarLocale));
      }
    };
    $[3] = calendarLocale;
    $[4] = showDates;
    $[5] = value;
    $[6] = view;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== value) {
    t2 = [value];
    $[8] = value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  useEffectJustChanges(t1, t2);
  let t3;
  if ($[10] !== calendarLocale || $[11] !== showDates.length) {
    t3 = () => {
      setShowDates(createShowDatesArray(calendarLocale, showDates.length));
    };
    $[10] = calendarLocale;
    $[11] = showDates.length;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== calendarLocale) {
    t4 = [calendarLocale];
    $[13] = calendarLocale;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  useEffectJustChanges(t3, t4);
  let t5;
  if ($[15] !== calendarLocale || $[16] !== showDates.length) {
    t5 = () => {
      setShowDates(createShowDatesArray(calendarLocale, showDates.length + 1));
    };
    $[15] = calendarLocale;
    $[16] = showDates.length;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const increaseShowDatesNumber = t5;
  let t6;
  if ($[18] !== calendarLocale) {
    t6 = getToday(calendarLocale);
    $[18] = calendarLocale;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const today = t6;
  let t7;
  if ($[20] !== showDates) {
    t7 = showDates.at(-1)?.year;
    $[20] = showDates;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== showDates) {
    t8 = showDates.at(-1)?.month;
    $[22] = showDates;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const nextMonthDisabled = (Number(t7) - today.year) * 12 + (Number(t8) - today.month) >= 12;
  const previousMonthDisabled = (showDates[0].year - today.year) * 12 + (showDates[0].month - today.month) <= 0;
  let t9;
  if ($[24] !== nextMonthDisabled || $[25] !== showDates) {
    t9 = () => {
      if (!nextMonthDisabled) {
        const newShowDates = showDates.map(_temp);
        setShowDates(newShowDates);
      }
    };
    $[24] = nextMonthDisabled;
    $[25] = showDates;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const onNextMonthClick = t9;
  let t10;
  if ($[27] !== previousMonthDisabled || $[28] !== showDates) {
    t10 = () => {
      if (!previousMonthDisabled) {
        const newShowDates_0 = showDates.map(_temp2);
        setShowDates(newShowDates_0);
      }
    };
    $[27] = previousMonthDisabled;
    $[28] = showDates;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const onPreviousMonthClick = t10;
  let t11;
  if ($[30] !== calendarLocale || $[31] !== isDesktop || $[32] !== scrollToTop) {
    t11 = () => {
      setShowDates(createShowDatesArray(calendarLocale, INITIAL_SHOW_DATES_NUMBER));
      if (!isDesktop) {
        scrollToTop();
      }
    };
    $[30] = calendarLocale;
    $[31] = isDesktop;
    $[32] = scrollToTop;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const onShowTodayClick = t11;
  let t12;
  if ($[34] !== increaseShowDatesNumber || $[35] !== nextMonthDisabled || $[36] !== onNextMonthClick || $[37] !== onPreviousMonthClick || $[38] !== onShowTodayClick || $[39] !== previousMonthDisabled || $[40] !== showDates) {
    t12 = {
      onNextMonthClick,
      onPreviousMonthClick,
      onShowTodayClick,
      showDates,
      increaseShowDatesNumber,
      nextMonthDisabled,
      previousMonthDisabled,
      setShowDates
    };
    $[34] = increaseShowDatesNumber;
    $[35] = nextMonthDisabled;
    $[36] = onNextMonthClick;
    $[37] = onPreviousMonthClick;
    $[38] = onShowTodayClick;
    $[39] = previousMonthDisabled;
    $[40] = showDates;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  return t12;
};
function _temp(item) {
  const newDate = addMonth(item.year, item.month, 1);
  return {
    year: newDate.year,
    month: newDate.month
  };
}
function _temp2(item_0) {
  const newDate_0 = subtractMonth(item_0.year, item_0.month, 1);
  return {
    year: newDate_0.year,
    month: newDate_0.month
  };
}